import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {TranscodingPreset} from '../../services/api/transcoding-presets';
import {UUID} from '../../shared/types/uuid.type';

/**
 * State interface for transcoding presets
 * Uses EntityState for normalized data storage with efficient lookups
 */
export interface TranscodingPresetsState extends EntityState<TranscodingPreset> {
  // Entity adapter provides: ids, entities

  // Loading states
  loading: boolean;
  loadingById: { [id: string]: boolean };
  creating: boolean;
  updating: { [id: string]: boolean };
  deleting: { [id: string]: boolean };

  // Error states
  error: string | null;
  createError: string | null;
  updateError: { [id: string]: string | null };
  deleteError: { [id: string]: string | null };

  // Metadata
  loaded: boolean;
  lastUpdated: number | null;
  selectedPresetId: string | null;
}

/**
 * Entity adapter for efficient CRUD operations
 * Provides methods like addOne, addMany, updateOne, removeOne, etc.
 */
export const transcodingPresetsAdapter: EntityAdapter<TranscodingPreset> =
  createEntityAdapter<TranscodingPreset>({
    selectId: (preset: TranscodingPreset): UUID => preset.id,
    sortComparer: (a: TranscodingPreset, b: TranscodingPreset): number => b.createdAt - a.createdAt // Sort by the newest first
  });

/**
 * Initial state for transcoding presets
 */
export const initialTranscodingPresetsState: TranscodingPresetsState =
  transcodingPresetsAdapter.getInitialState({
    loading: false,
    loadingById: {},
    creating: false,
    updating: {},
    deleting: {},
    error: null,
    createError: null,
    updateError: {},
    deleteError: {},
    loaded: false,
    lastUpdated: null,
    selectedPresetId: null
  });
